import React from "react"
import PropTypes from "prop-types"

import LexicoinHistory from './LexicoinHistory'

class LexicoinCounter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      historyOpen: false
    }

    this.toggleHistory = this.toggleHistory.bind(this)
  }

  toggleHistory() {
    this.setState({
      historyOpen: !this.state.historyOpen
    })
  }

  renderCoinIcon() {
    if (this.props.lexicoinIcon) {
      return (
        <img
          src={this.props.lexicoinIcon}
          alt=""
          className="lexicoinCounter__coinImg"
        />
      )
    }

    return <span className="lexicoinCounter__coinFallback lexicoin" aria-hidden="true" />
  }

  render() {
    return(
      <div className="lexicoinCounterWrap">
        <button
          type="button"
          className="lexicoinCounter"
          onClick={this.toggleHistory}
          aria-label={`${this.props.lexicoins} lexicoins. View history`}
        >
          <span className="lexicoinCounter__coin" aria-hidden="true">
            {this.renderCoinIcon()}
          </span>
          <span className="lexicoinCounter__count">{this.props.lexicoins}</span>
        </button>
        {this.state.historyOpen &&
          <LexicoinHistory
            onClose={this.toggleHistory}
            lexicoins={this.props.lexicoins}
            lexicoinIcon={this.props.lexicoinIcon}
          />
        }
      </div>
    )
  }

}

LexicoinCounter.propTypes = {
  lexicoins: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  lexicoinIcon: PropTypes.string,
}

export default LexicoinCounter
